import { ref } from "vue";
import { useRouter } from "vue-router";
import { useUserStore } from "@/stores/user";
import { useNotifications } from "@/stores/notifications";
import { ResetPasswordSchema } from "../validations/schemas";

export function useResetPassword(resetToken) {
  const userStore = useUserStore();
  const router = useRouter();
  const notifications = useNotifications();
  const formData = ref({ resetToken });
  const errors = ref({});
  const submitError = ref(null);

  async function handleSubmit() {
    errors.value = {};
    submitError.value = null;

    try {
      ResetPasswordSchema.parse(formData.value);
      const res = await userStore.resetPassword(
        formData.value.resetToken,
        formData.value.password,
        formData.value.passwordConfirmation,
      );
      if (res.success) {
        notifications.send(
          "Your password has been updated successfully. You can sign in with your new password now.",
          "success",
          true,
        );
        router.push({ name: "SignIn" });
      } else {
        submitError.value = res.error;
      }
    } catch (formValidationError) {
      errors.value = formValidationError.errors.reduce((acc, err) => {
        acc[err.path[0]] = err.message;
        return acc;
      }, {});
    }
  }

  return {
    formData,
    errors,
    submitError,
    handleSubmit,
  };
}
